/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IDepositorUpdateMutationVariables = Types.Exact<{
  depositorId: Types.Scalars['ID']['input'];
  depositorParams: Types.IEscrowPartyParams;
}>;

export type IDepositorUpdateMutation = {
  __typename?: 'Mutation';
  depositorUpdate?: {
    __typename?: 'DepositorUpdatePayload';
    success: boolean;
    errors?: Array<string> | null;
    depositor: {
      __typename?: 'Depositor';
      city?: string | null;
      companyName?: string | null;
      companyRegistrationNumber?: string | null;
      companyWebsite?: string | null;
      country?: string | null;
      id: string;
      postalCode?: string | null;
      region?: string | null;
      street?: string | null;
      streetNumber?: string | null;
    };
  } | null;
};

export const DepositorUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'depositorUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'depositorId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'depositorParams' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'EscrowPartyParams' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'depositorUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'depositorId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'depositorId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'depositorParams' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'depositorParams' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'depositor' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyRegistrationNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyWebsite' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetNumber' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IDepositorUpdateMutation, IDepositorUpdateMutationVariables>;
